import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import {
  SPACING_2,
  SPACING_3,
  SPACING_4,
  SPACING_5,
  SPACING_6,
} from 'constants/theme-constants';
import styled from 'styled-components';

export const StackedBarWrapper = styled.div`
  ${({ theme }) => `
    position: relative;
    height: ${cxTheme.spacing[SPACING_6]};
    border-radius: ${cxTheme.borderRadius.primaryRadius};
    display: flex;
    z-index: 2;
`}
`;

export const RevenueBreakdownWrapper = styled.div`
  ${({ theme }) => `
    width: 100%;
    padding-bottom: ${cxTheme.spacing[SPACING_2]};
`}
`;

export const RevenueBreakdownRow = styled.div<{
  $fill?: boolean;
}>`
  ${({ theme, $fill }) => `
    display:flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: ${cxTheme.spacing[SPACING_2]} ${cxTheme.spacing[SPACING_5]} ${cxTheme.spacing[SPACING_2]};

    &:nth-child(odd) {
      background-color: ${theme.background.base};
    }
  `}
`;

export const RevenueBreakdownItem = styled.div`
  ${({ theme }) => `
    display: flex;
    gap: ${cxTheme.spacing[SPACING_2]};
    align-items: center;
  `}
`;

export const RevenueBreakdownPrice = styled.div`
  ${({ theme }) => `
    color: ${theme.text.onSurface.information};
    ${theme.label.medium.normal}
  `}
`;

export const StackedBarItem = styled.div`
  ${({ theme }) => `
    height: 100%;
    z-index: 1;

    &:first-child {
      border-top-left-radius: ${cxTheme.borderRadius.primaryRadius};
      border-bottom-left-radius: ${cxTheme.borderRadius.primaryRadius};
    }

    &:last-of-type {
      border-top-right-radius: ${cxTheme.borderRadius.primaryRadius};
      border-bottom-right-radius: ${cxTheme.borderRadius.primaryRadius};
    }
  `}
`;

export const StackedBarItemBorder = styled.span<{
  $width: number;
}>`
  ${({ theme, $width }) => `
  background-color: transparent;
  left: ${$width}%;
  margin-left: -1px;
  position: absolute;
  z-index: 2;
  color: black;
  height: ${cxTheme.spacing[SPACING_6]};
  ${theme.label.medium.normal};
  line-height: inherit;
  `}
`;
StackedBarItemBorder.displayName = 'StackedBarItemBorder';

export const StackedBarItemZero = styled.div<{
  $theme: string;
}>`
  ${({ $theme }) => `
    margin-left: -6px;
    margin-top: -8px;
    color: ${$theme === 'light' ? '#343434' : '#FFFFFF'};
  `}
`;

export const RevenueBreakdownHint = styled.div`
  ${({ theme }) => {
    return `
    padding: 0 ${cxTheme.spacing[SPACING_5]};
    ${theme.label.small.normal};
    color: ${theme.text.onSurface.information};
  `;
  }}
`;

export const RevenueBreakdownTextWrapper = styled.div`
  ${({ theme }) => `
    padding: ${cxTheme.spacing[SPACING_4]} 0;
    padding-bottom: 0;
  `}
`;

export const NegativeRevenueTooltip = styled.div`
  ${({ theme }) => `
    padding: ${cxTheme.spacing[SPACING_3]} ${cxTheme.spacing[SPACING_5]};
    display: flex;
    align-items: center;
    max-width: 100%; 
    gap: 10px;
    
    svg {
      fill: ${theme.text.onSurface.information};
    }
  `}
`;

export const NegativeRevenueLabel = styled.span`
  ${({ theme }) => `
    ${theme.label.medium.bold};
    color: ${theme.text.onSurface.information};
  `}
`;
